/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback } from 'react';
import { MODAL_ID } from '@jira/navigation-apps__atlassian-navigation-ui/src/constants.tsx';
import CreateDashboardModal from '@jira/global-pages__directories-dashboards-directory-v2-create-dashboard-modal/src/async.tsx';
import { useRouteByName } from '@jira/platform__utils-router/src/index.tsx';
import { useSwitchModals } from '@jira/platform__controllers-switch-modals/src/index.tsx';
import { xcss } from '@atlaskit/primitives/xcss';
import Box from '@atlaskit/primitives/box';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { useRouterActions, generatePath } from '@atlassian/react-resource-router';

const styles = xcss({ position: 'absolute' });

export const Dashboards = (): React.JSX.Element | null => {
	const isAnonymous = useIsAnonymous();
	const [isOpen, { off: modalClose }] = useSwitchModals(MODAL_ID.DASHBOARD_CREATE);
	const { path } = useRouteByName('dashboard-edit') ?? {};
	const { push } = useRouterActions();
	const onSuccess = useCallback(
		// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
		(_, { id }) => {
			path && push(generatePath(path, { dashboardId: id }));
			modalClose();
		},
		[modalClose, path, push],
	);

	if (isAnonymous) {
		return null;
	}

	return isOpen ? (
		<Box xcss={styles}>
			<CreateDashboardModal onSuccess={onSuccess} onCancel={modalClose} />
		</Box>
	) : null;
};
